import { useState } from 'react'

import { QuizResult } from '../QuizResult'

import QuizQuestion from './QuizQuestion'

const quiz = {
  id: 'f888e59a-82b5-4af6-ae48-bed2501215b2',
  questions: [
    {
      id: '851e9483-34f0-4e85-b5db-ee511130134a',
      answers: [
        {
          title: 'Towels',
          display_order: 0,
        },
        {
          title: 'Trauma Shears',
          display_order: 1,
        },
        {
          title: 'First aid kit',
          display_order: 2,
        },
        {
          title: 'Band-aids',
          display_order: 3,
        },
        {
          title: 'AED',
          display_order: 4,
        },
        {
          title: 'O2 Kit',
          display_order: 5,
        },
      ],
      created_at: '2025-09-08T13:04:01.965016-06:00',
      modified_at: '2025-09-08T13:04:05.163979-06:00',
      type: 'Multiple Choice',
      text: 'What equipment is required for post extrication care?',
      order: 0,
    },
    {
      id: '42d339d2-51ff-4398-9733-8ca2774517c9',
      answers: [
        {
          title: 'Removing the divers fins',
          display_order: 0,
        },
        {
          title: 'Beginning care via compressions',
          display_order: 1,
        },
        {
          title: 'Going and retrieving 02 kit',
          display_order: 2,
        },
        {
          title: 'Standing by in the beginning',
          display_order: 3,
        },
      ],
      created_at: '2025-09-08T13:04:01.968086-06:00',
      modified_at: '2025-09-08T13:04:05.168357-06:00',
      type: 'Single Choice',
      text: "The dry-side rescuer on the patient's right side (also known as primary rescuer) is responsible for?",
      order: 1,
    },
    {
      id: '7362d25b-ebda-423b-a338-017bd22a1047',
      answers: [
        {
          title: 'True',
          display_order: 0,
        },
        {
          title: 'False',
          display_order: 1,
        },
      ],
      created_at: '2025-09-08T13:04:01.971432-06:00',
      modified_at: '2025-09-08T13:04:05.172110-06:00',
      type: 'True/False',
      text: 'The Orange strap is considered the "Chest strap" and goes under the arm pits?',
      order: 2,
    },
    {
      id: '36036459-5807-4f3a-b8d2-f8fc48e1ecb9',
      answers: [
        {
          title: '1',
          display_order: 0,
        },
      ],
      created_at: '2025-09-08T13:04:01.972719-06:00',
      modified_at: '2025-09-08T13:04:05.176178-06:00',
      type: 'Numeric',
      text: 'How many people are required to open the RescueX board?',
      order: 3,
    },
    {
      id: '5e0f0e6f-bc7b-4f97-acef-e9798dcdc9e4',
      answers: {
        template: [
          'After you have completed your dive you should remain at the same elevation for at least',
          null,
          'or up to',
          null,
          'if you have done multiple dives in a day,',
        ],
        answers: ['12', '36', '48', '24'],
      },
      created_at: '2025-09-08T13:04:01.974928-06:00',
      modified_at: '2025-09-08T13:04:05.180136-06:00',
      type: 'Drag and Drop',
      text: '',
      order: 4,
    },
  ],
  attempt_count: 0,
  created_at: '2025-09-02T14:17:23.503844-06:00',
  modified_at: '2025-09-05T14:33:59.601358-06:00',
  name: 'More info',
  num_questions_to_display: 5,
  num_questions_to_pass: 1,
  num_of_retries_allowed: 3,
}

const gradedQuiz = {
  id: '7003a7ab-6560-4abf-be0b-6e453e92690a',
  answers: [
    {
      questionId: '851e9483-34f0-4e85-b5db-ee511130134a',
      answers: ['Towels', 'Trauma Shears'],
      isCorrect: false,
      correctAnswers: ['Band-aids', 'First aid kit', 'Towels', 'Trauma Shears'],
    },
    {
      questionId: '42d339d2-51ff-4398-9733-8ca2774517c9',
      answers: ['Going and retrieving 02 kit'],
      isCorrect: false,
      correctAnswers: ['Removing the divers fins'],
    },
    {
      questionId: '7362d25b-ebda-423b-a338-017bd22a1047',
      answers: ['True'],
      isCorrect: true,
      correctAnswers: ['True'],
    },
    {
      questionId: '36036459-5807-4f3a-b8d2-f8fc48e1ecb9',
      answers: ['2'],
      isCorrect: false,
      correctAnswers: ['1'],
    },
    {
      questionId: '5e0f0e6f-bc7b-4f97-acef-e9798dcdc9e4',
      answers: ['12', '36'],
      isCorrect: false,
      correctAnswers: ['24', '36'],
    },
  ],
  attempt_number: 1,
  created_at: '2025-09-05T14:40:55.477096-06:00',
  modified_at: '2025-09-05T14:40:55.477145-06:00',
  score: 2.0,
  result: 'Passed',
}

function Demo() {
  const [answer, setAnswer] = useState({})
  return (
    <div className="mx-auto max-w-3xl py-20">
      <div className="mb-4 rounded border-2 p-4">
        {quiz.questions.map((question, index) => (
          <div key={question.id} style={{ marginBottom: '2rem' }}>
            <h3>
              {2 * index + 1}. {question.text} ({question.type})
            </h3>
            <pre>{JSON.stringify(answer[question.id], null, 2)}</pre>
            <QuizQuestion
              question={question}
              setAnswer={setAnswer}
              isLastQuestion={index === quiz.questions.length - 1}
            />
            <hr />
            <h3>
              {2 * index + 2}. {question.text} ({question.type})
            </h3>
            <pre>{JSON.stringify(answer[question.id], null, 2)}</pre>
            <QuizQuestion
              question={{ ...question, signedImagePath: '/src/assets/images/quiz.jpg' }}
              setAnswer={setAnswer}
              isLastQuestion={index === quiz.questions.length - 1}
            />
            <hr />
          </div>
        ))}
      </div>
      <div className="rounded border-2 p-4">
        <QuizResult quiz={quiz} gradedQuiz={gradedQuiz} />
        <QuizResult
          quiz={{
            ...quiz,
            questions: quiz.questions.map((question) => ({
              ...question,
              signedImagePath: '/src/assets/images/quiz.jpg',
            })),
          }}
          gradedQuiz={gradedQuiz}
        />
      </div>
    </div>
  )
}
export default Demo
